<template>
  <div v-if="stubInfo" class="online-stub">
    <ProductBanner
      class="online-stub__banner"
      title="Kaspi Red"
      :info="stubInfo.additional_text"
    >
      <template #subtitle>
        <div class="online-stub__banner_subtitle">
          <span> {{ stubInfo.text }} </span>
        </div>
      </template>
    </ProductBanner>
    <DashboardStub :stubInfo="stubInfo" />
  </div>
</template>

<script>
import { getOnlineStub } from "@/api/dashboard";
import ProductBanner from "@/components/shared/banner/ProductBanner";
import DashboardStub from "@/components/dashboard/DashboardStub";

export default {
  components: {
    DashboardStub,
    ProductBanner,
  },
  data() {
    return {
      stubInfo: null,
    };
  },
  async created() {
    this.stubInfo = await getOnlineStub();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.online-stub {
  &__banner {
    &_subtitle {
      margin-bottom: 8px;

      & > span {
        padding: 3px 5px;
        background-color: white;
        color: $colorRed;
      }
    }
  }
}
</style>
